import { getModeNavigationItems } from "@catchy/region-config";

function escapeXml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
}

export function createSitemapXml(entries) {
  const urls = entries
    .map(
      ({ url, lastModified }) => `  <url>
    <loc>${escapeXml(url)}</loc>
    <lastmod>${escapeXml(lastModified.toISOString())}</lastmod>
  </url>`,
    )
    .join("\n");

  return `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urls}
</urlset>`;
}

// Only publish mode routes that already exist in the regional app.
export function getSitemapPagePaths(regionId) {
  return [
    ...new Set([
      ...getModeNavigationItems(regionId).map(({ href }) => href.slice(1)),
      "about",
      "age-suitability",
      "map",
      "privacy",
      "terms",
    ]),
  ];
}
